var _desc, _rect, _rect2, _circle, _circle2, _circle3, _line, _line2, _line3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Schedule Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Church schedule and calendar icon")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 60,
    height: 50,
    rx: 4,
    fill: "#F5F0E6",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 60,
    height: 12,
    rx: 4,
    fill: "#E5DECF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 3,
    fill: "none",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 20,
    r: 3,
    fill: "none",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 20,
    r: 3,
    fill: "none",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 45,
    x2: 70,
    y2: 45,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 55,
    x2: 70,
    y2: 55,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 65,
    x2: 70,
    y2: 65,
    stroke: "#5F7A61",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 50,
    r: 2,
    fill: "#5F7A61"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 2,
    fill: "#5F7A61"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 60,
    r: 2,
    fill: "#5F7A61"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 60,
    r: 2,
    fill: "#5F7A61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule-icon.9e9940cb17afb73ea2416557fb56b661.svg";
export { ForwardRef as ReactComponent };